/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const TOOLS_SERVICE = {
    list,
    add,
    edit,
    get,
    updateStatus
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Tools";

/* Services */
function list(pageNumber, resultsNumber, searchText, status, orderBy)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetTools"]);    
    var queryParams = {"pageNumber":pageNumber, "resultsNumber":resultsNumber, "searchText":searchText, "status": status, "orderBy": orderBy};

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function add(tool, photo) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "RegisterTool"]); 
    
    var jsonTool = JSON.stringify(tool, (key, value) => {
        if (value !== null) return value
      });

    let formData = new FormData();
    formData.append("data", jsonTool);
    if(photo)
    {
        formData.append("photo", photo);
    }

    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function edit(id, tool, photo) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "UpdateTool", id]); 

    let formData = new FormData();
    formData.append("data", JSON.stringify(tool));
    if(photo)
    {
        formData.append("photo", photo);
    }

    console.log(JSON.stringify(tool));

    const requestOptions = {
        method: 'PUT',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function get(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetTool", id]);    
    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function updateStatus(id, status) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "UpdateStatus", id, status]); 
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}